import { gql } from 'urql';

const AdvanceEligibilityScreenContent = gql`
  query AdvanceEligibilityScreenContent {
    advanceScreensContent {
      howToQualifyScreenContent {
        title
        description
        subTitleGroups {
          subTitle
          bullets
        }
        content
        termsAndConditionsCopy
      }
    }
  }
`;

export default AdvanceEligibilityScreenContent;
